import React from 'react';
import { pureRender } from 'epic-alt-utils';
import { NavActions } from '../../actions';
import debounce from 'lodash/debounce';
import './dividerLine.sass';

@pureRender
export default class DividerLine extends React.Component {
    constructor(props) {
        super(props);

        this.toggleTabletMenuDebounce = debounce(this.toggleTabletMenu.bind(this), 10);
    }

    componentDidUpdate() {
        if (!this.context.isTablet) {
            NavActions.tabletNavActive.defer(false);
        }
    }

    toggleTabletMenu() {
        if (!this.props.isActive && this.context.isTablet) {
            NavActions.tabletNavActive(true);
            NavActions.mobileNavActive(false);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.tabletNavActive(false);
            NavActions.mobileNavActiveLinks(false);
        }

        //Reset all other clickable items
        NavActions.searchActive(false);
        NavActions.egNavActive(false);
        NavActions.mobileActiveLinkIndex(null);
    }

    render() {
        return (
            <div
                id="navLine"
                className={`nav-line ${this.props.isActive ? 'active rightnav-bg-color' : ''} ${this.props.searchActive ? 'search-active' : ''}`}
                onClick={this.toggleTabletMenuDebounce}>
                <span className="lines text-color-bg text-color-before-after"></span>
            </div>
        );
    }
}

DividerLine.propTypes = {
    isActive: React.PropTypes.bool,
    searchActive: React.PropTypes.bool
};

DividerLine.contextTypes = {
    isTablet: React.PropTypes.bool,
    isDesktop: React.PropTypes.bool,
    isActive: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/dividerLine/DividerLine.js
 **/